const config = {
  development: {
    SIGNUP_LINK: 'https://signup.safapply.flexisafapps-dev.com',
    API_BASE_URL: 'https://api.safapply.flexisafapps-dev.com',
    SAFBILLING_BASE_URL: 'https://api.safbilling.flexisafapps-dev.com',
    AI_BASE_URL: 'https://ai-api.safapply.flexisafapps-dev.com/v1/safapply-ai',
    FORM_API_BASE_URL: 'https://api.fbs.flexisafapps-dev.com',
    FORM_DATA_BASE_URL: 'https://fbs.flexisafapps-dev.com',
    FORM_DATA_REPOSITORY: 'https://api.fds.flexisafapps-dev.com',
    UMS_BASE_URL: 'https://api.ums.flexisafapps-dev.com',
    TEMPLATE_BASE_URL: 'https://api.ts.flexisafapps-dev.com',
    GA_MEASUREMENT_ID: 'G-EEBNBHYL2Q',
    GTM_ID: 'GTM-M7CCLCF',
    TINYMCE_KEY: 'nwtx8785vktbbbqadu4o8ddza1s2abp1hqat5niqpjyvr1fk',
    WEB_SOCKET: 'ws',
    APPLICANT_URL: 'http://applicant.safapply.flexisafapps-dev.com',
    BUGSNAG_API_KEY: '4e45968326683a41fccc832f7a1a638d',
  },
  staging: {
    SIGNUP_LINK: 'https://signup.safapply.flexisafapps-dev.com',
    API_BASE_URL: 'https://api.safapply.flexisafapps-stage.com',
    FORM_API_BASE_URL: 'https://api.fbs.flexisafapps-stage.com',
    SAFBILLING_BASE_URL: 'https://api.safbilling.flexisafapps-dev.com',
    FORM_DATA_BASE_URL: 'https://fbs.flexisafapps-stage.com',
    FORM_DATA_REPOSITORY: 'https://api.fds.flexisafapps-stage.com',
    UMS_BASE_URL: 'https://api.ums.flexisafapps-stage.com',
    TEMPLATE_BASE_URL: 'https://api.ts.flexisafapps-stage.com',
    GA_MEASUREMENT_ID: 'G-442S1ETN2T',
    GTM_ID: 'GTM-NMCV3KS',
    TINYMCE_KEY: 'nwtx8785vktbbbqadu4o8ddza1s2abp1hqat5niqpjyvr1fk',
    WEB_SOCKET: 'wss',
    APPLICANT_URL: 'https://applicant.safapply.flexisafapps-stage.com',
    BUGSNAG_API_KEY: '41daa39b90352c8ab313eac84e75d5cd',
  },
  production: {
    SIGNUP_LINK: 'https://signup.safapply.com/',
    API_BASE_URL: 'https://api.safapply.com',
    SAFBILLING_BASE_URL: 'https://api.safbilling.flexisaf.com',
    FORM_API_BASE_URL: 'https://form-builder-api.component.flexisaf.com',
    FORM_DATA_BASE_URL: 'https://form-builder.component.flexisaf.com',
    FORM_DATA_REPOSITORY: 'https://form-data-api.component.flexisaf.com',
    UMS_BASE_URL: 'https://ums-api.component.flexisaf.com',
    TEMPLATE_BASE_URL: 'https://ts-api.component.flexisaf.com',
    GA_MEASUREMENT_ID: 'G-4TPDYPDT0V',
    GTM_ID: 'GTM-5F5MJG2',
    TINYMCE_KEY: 'nwtx8785vktbbbqadu4o8ddza1s2abp1hqat5niqpjyvr1fk',
    WEB_SOCKET: 'wss',
    APPLICANT_URL: 'https://applicant.safapply.com',
    BUGSNAG_API_KEY: 'f71c83a1e16ccf5a6c58927f251a3f5f',
  },
  // Local UI against a locally running API
  local: {
    SIGNUP_LINK: 'https://signup.safapply.flexisafapps-dev.com',
    API_BASE_URL: 'http://localhost:8081',
    SAFBILLING_BASE_URL: 'https://api.safbilling.flexisafapps-dev.com',
    AI_BASE_URL: 'https://ai-api.safapply.flexisafapps-dev.com/v1/safapply-ai',
    // Local API serves ATPP design + seed-form-* payloads for Dummy Application 2026
    FORM_API_BASE_URL: 'http://localhost:8081',
    FORM_DATA_BASE_URL: 'https://fbs.flexisafapps-dev.com',
    FORM_DATA_REPOSITORY: 'http://localhost:8081',
    UMS_BASE_URL: 'https://api.ums.flexisafapps-dev.com',
    TEMPLATE_BASE_URL: 'https://api.ts.flexisafapps-dev.com',
    GA_MEASUREMENT_ID: 'G-EEBNBHYL2Q',
    GTM_ID: 'GTM-M7CCLCF',
    TINYMCE_KEY: 'nwtx8785vktbbbqadu4o8ddza1s2abp1hqat5niqpjyvr1fk',
    WEB_SOCKET: 'ws',
    APPLICANT_URL: 'http://localhost:3001',
    BUGSNAG_API_KEY: '4e45968326683a41fccc832f7a1a638d',
  },
};

export default config[
  process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development'
];
